import { useMutation } from '@tanstack/react-query';
import useAxios from '../../../../../app/hooks/useAxios';

const useAuthOktaUserActivationResend = () => {
	const { post } = useAxios();

	const userActivateResend = (data: { login: string; locale?: string }) => {
		return post(`/users/activate/resend`, { login: data.login, language: data.locale ?? null });
	};

	return useMutation(userActivateResend);
};

export default useAuthOktaUserActivationResend;
